import {
  FaReact,
  FaMapMarkedAlt,
  FaHome,
  FaCalendarWeek,
  FaRadiation,
  FaChartLine,
  FaPlus,
  FaBriefcase,
} from 'react-icons/fa';

import { BiTask, BiSolidReport } from 'react-icons/bi';
import { IoPeople } from 'react-icons/io5';
import { MdPlayLesson } from 'react-icons/md';
import { IoMdSettings } from 'react-icons/io';
import type { JSX } from 'react';
import { FaBook } from 'react-icons/fa6';
import { AllPermissions } from '../types/serverTypes';
// import { IoMdArrowDropright } from 'react-icons/io';

export type NavButtonType = {
  to: string;
  icon: JSX.Element;
  label: string;
  permission: AllPermissions | AllPermissions[] | null;
  subnav?: {
    to: string;
    label: string;
    permission: AllPermissions | AllPermissions[] | null;
  }[];
};

export const navButtons: NavButtonType[] = [
  { to: '/', icon: <FaChartLine />, label: 'Dashboard', permission: null },
  {
    to: '/playbook',
    icon: <MdPlayLesson />,
    label: 'Playbook',
    permission: 'playbook',
  },
  {
    to: '/schedule',
    icon: <FaPlus />,
    label: 'Schedule',
    permission: 'scheduler',
    subnav: [
      {
        to: '/contacts',
        label: 'Contacts',
        permission: 'scheduler',
      },
    ],
  },
  {
    to: '/calendar',
    icon: <FaCalendarWeek />,
    label: 'Calendar',
    permission: [
      'calendar-admin',
      'calendar-office',
      'scheduler',
      'calendar-self',
      'calendar-inspector',
    ],
    subnav: [
      {
        to: '/calendar',
        label: 'Inspector Calendar',
        permission: ['calendar-inspector', 'calendar-self'],
      },
      {
        to: '/calendar/office',
        label: 'Office Calendar',
        permission: 'calendar-office',
      },
    ],
  },
  {
    to: '/radon',
    icon: <FaRadiation />,
    label: 'Radon Chart',
    permission: ['calendar-admin', 'calendar-office', 'scheduler'],
  },

  // {
  //   to: '/radon-tracking',
  //   icon: <FaReact />,
  //   label: 'Radon Tracking',
  //   permission: 'radon',
  // },
  {
    to: '/dispatch',
    icon: <FaMapMarkedAlt />,
    label: 'Dispatch ',
    permission: ['calendar-admin', 'calendar-office', 'scheduler', 'calendar'],
  },
  {
    to: '/work/quotes',
    icon: <FaBriefcase />,
    label: 'Worklists',
    permission: 'tasks',
  },
  {
    to: '/tasks',
    icon: <BiTask />,
    label: 'Tasks',
    permission: 'tasks',
    subnav: [
      {
        to: '/tasks',
        label: 'Mission Control',
        permission: 'tasks',
      },
      {
        to: '/tasks/all-tasks',
        label: 'All Tasks',
        permission: 'tasks',
      },
      // {
      //   to: '/tasks/checks',
      //   label: 'Task Checks',
      //   permission: 'tasks',
      // },
    ],
  },

  // {
  //   to: '/help-docs',
  //   icon: <IoDocumentText />,
  //   label: 'Help Docs',
  //   permission: 2,
  // },
  {
    to: '/data-exports',
    icon: <BiSolidReport />,
    label: 'Reports Hub',
    permission: 'data-exports',
  },
  {
    to: '/handbook',
    icon: <FaBook />,
    label: 'Company Handbook',
    permission: 'handbook',
    subnav: [
      {
        to: '/handbook/office',
        label: 'Office Help Docs',
        permission: 'handbook',
      },
      {
        to: '/handbook/inspector',
        label: 'Inspector Handbook',
        permission: 'handbook',
      },
      {
        to: '/service-matrix',
        label: 'Service Matrix',
        permission: 'handbook-office',
      },
    ],
  },
  {
    to: '/hr',
    icon: <IoPeople />,
    label: 'Human Resource',
    permission: 'human',
  },
];

export const footButtons = [
  {
    to: '/settings',
    icon: <IoMdSettings />,
    label: 'Settings',
    permission: null,
  },
];
